import { render, staticRenderFns } from "./step-transfer.vue?vue&type=template&id=447bd14c&scoped=true&"
import script from "./step-transfer.vue?vue&type=script&lang=js&"
export * from "./step-transfer.vue?vue&type=script&lang=js&"
import style0 from "./step-transfer.vue?vue&type=style&index=0&id=447bd14c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "447bd14c",
  null
  
)

export default component.exports